// Файл page_load_mobile_version.js

import { useEffect, useRef, useState } from 'react';
import {
    API_BASE_URL,
    apiService,
} from '../services/api.js';
import {
    getImage,
    getImageStatic,
} from '../components/DropdownButton/utils/image';
import { useToast } from '../components/Toast';
import {
    ChangelogItem,
    HISTORY_BATCH_SIZE,
} from './page_load_mobile_version_history';
import '../lk_templates_styling/page_load_mobile_version.css';



const load_version_history = async () => {
    const response = await fetch(
        `${API_BASE_URL}/api/df_app_potale_version`,
        {
            credentials: 'include',
        },
    );
    const payload = await response.json();

    if (!response.ok) {
        throw new Error(
            payload?.response
            || 'Не удалось загрузить историю версий',
        );
    }

    return Array.isArray(payload?.data)
        ? payload.data
        : [];
};


const Page_load_mobile_version = () => {
    const [df_app_potale_version, set_df_app_potale_version] = useState([]);
    const [history_loading, set_history_loading] = useState(true);
    const [history_error, set_history_error] = useState('');
    const [history_visible_count, set_history_visible_count] = useState(
        HISTORY_BATCH_SIZE,
    );
    const history_container_ref = useRef(null);
    const { showToast } = useToast();

    useEffect(() => {
        const load_table = async () => {
            try {
                const rows = await load_version_history();

                set_df_app_potale_version(rows);
                set_history_visible_count(HISTORY_BATCH_SIZE);
                set_history_error('');

            } catch (error) {
                const message = String(
                    error?.message
                    || 'Не удалось загрузить историю версий',
                );

                set_history_error(message);
                showToast(message, 'error');

            } finally {
                set_history_loading(false);
            }
        };

        load_table();
    }, []);

    const handle_history_scroll = (event) => {
        const container = event.currentTarget;
        const distance_to_bottom = (
            container.scrollHeight
            - container.scrollTop
            - container.clientHeight
        );

        if (distance_to_bottom <= 200) {
            set_history_visible_count((current) => Math.min(
                current + HISTORY_BATCH_SIZE,
                df_app_potale_version.length,
            ));
        }
    };

    useEffect(() => {
        const handle_window_scroll = () => {
            const container = history_container_ref.current;

            if (!container) {
                return;
            }

            const distance_to_viewport = (
                container.getBoundingClientRect().bottom
                - window.innerHeight
            );

            if (distance_to_viewport <= 200) {
                set_history_visible_count((current) => Math.min(
                    current + HISTORY_BATCH_SIZE,
                    df_app_potale_version.length,
                ));
            }
        };

        window.addEventListener(
            'scroll',
            handle_window_scroll,
            { passive: true },
        );

        return () => {
            window.removeEventListener(
                'scroll',
                handle_window_scroll,
            );
        };
    }, [df_app_potale_version.length]);

    const go_back = () => {
        window.history.back();
    };

    const load_mobile = async () => {
        try {
            await apiService.download_file(
                'load_mobile',
                'Potale.apk',
            );

            showToast('Мобильное приложение скачено');

        } catch (error) {
            showToast(error, 'error');
        }
    };

    const image_house = getImage({
        file_name: 'Жилой_дом_3.png',
        version: '20260730-png',
    });
    const button_download = getImageStatic({
        image: 'button_download.png',
    });

    return (
        <div className="page_load_mobile_version">
            <div className="left-section">
                <button
                    className="back-button"
                    type="button"
                    onClick={go_back}
                    aria-label="Вернуться назад"
                >
                    <span aria-hidden="true">←</span>
                    Назад
                </button>

                <h1>Мобильное приложение Potale</h1>

                <div className="app-image">
                    <img
                        src={image_house}
                        alt="Potale"
                    />
                </div>

                <p className="app-description">
                    После скачивания приложения его нужно установить.
                    При установке может всплывать предупреждение о том,
                    что оно небезопасно. Не обращайте внимание на это
                    предупреждение, оно безопасное (сами делали).
                    Если не хотите скачивать мобильное приложение,
                    то можете установить ярлык сайта на рабочий стол.
                    Для этого выполните следующие действия: если у вас
                    Яндекс браузер, то внизу справа кликните на 2 строчки,
                    далее нажмите на "Добавить ярлык на рабочий стол"
                </p>

                <button
                    type="button"
                    onClick={load_mobile}
                >
                    <img
                        src={button_download}
                        alt="Скачать"
                        style={{
                            width: '42px',
                            height: '42px',
                        }}
                    />
                    Скачать
                </button>
            </div>

            <div className="right-section">
                <h2 className="history-title">
                    История версий
                </h2>

                {history_loading && (
                    <div className="history-status">
                        Загрузка истории версий...
                    </div>
                )}

                {!history_loading && history_error && (
                    <div className="history-status history-status-error">
                        {history_error}
                    </div>
                )}

                {!history_loading
                    && !history_error
                    && df_app_potale_version.length === 0 && (
                    <div className="history-status">
                        История версий пока отсутствует.
                    </div>
                )}

                {!history_loading
                    && !history_error
                    && df_app_potale_version.length > 0 && (
                    <div
                        ref={history_container_ref}
                        className="changelog-container"
                        onScroll={handle_history_scroll}
                    >
                        <div className="changelog">
                            {df_app_potale_version
                                .slice(0, history_visible_count)
                                .map((row, index) => (
                                    <ChangelogItem
                                        key={[
                                            row['Version_number'],
                                            row['Release date'],
                                            index,
                                        ].join('-')}
                                        row={row}
                                    />
                                ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};


export default Page_load_mobile_version;
